import ApiLoading from '@components/Api/ApiLoading';
import ApiContext from '@context/ApiContext';
import { Box } from '@mui/material';
import { use } from 'react';
import { ApiGuardProps } from 'types/ApiProvider.types';

/**
 * ApiGuard component
 *
 * This component guards the rendering of child components based on the API client initialization status.
 * It displays a loading indicator while the API clients are being initialized, and an error message if initialization fails.
 * @param children - Children to render if API clients are initialized
 */
const ApiGuard = ({ children }: ApiGuardProps) => {
  const { isInitialized, initError } = use(ApiContext);

  if (!isInitialized) {
    // Show Api loading indicator
    return <ApiLoading />;
  }

  if (initError) {
    return (
      <Box className='api-guard__error-container'>
        <p>Error initializing API clients:</p>
        <p>{initError.message}</p>
      </Box>
    );
  }

  // If Apis are loaded, render the children content
  return children;
};

export default ApiGuard;
